import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noColumnsHeaderText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noColumnsDescriptionText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	configureColumns: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noColumnsHeaderText: {
		id: 'native-issue-table.issue-table.no-columns.no-columns-header-text',
		defaultMessage: 'Configure your columns',
		description: 'Message shown when no columns have been selected.',
	},
	noColumnsDescriptionText: {
		id: 'native-issue-table.issue-table.no-columns.no-columns-description-text',
		defaultMessage:
			"You haven't configured any columns yet. Add fields as columns to see search results and their information.",
		description: 'Supplementary message shown when no columns have been selected.',
	},
	configureColumns: {
		id: 'native-issue-table.issue-table.no-columns.configure-columns',
		defaultMessage: 'Configure columns',
		description: 'CTA button copy shown when no columns have been selected.',
	},
});
export default messages;
